<template>
  <div id="progression-report-wrapper">
    <div class="contentSection custom-padding mb-3 mt-0">
      <div class="row set-report-selects">
          <BaseIconSelect
            v-if="set"
            customClass="col-md-4"
            :icon="{css: 'fas fa-calendar'}"
            v-model="set"
            @select="(value) => { setActiveSet(value) }"
            :items="setsReport"/>
            <div class="col-md-4"></div>
          <BaseIconSelect
            customClass="col-md-4"
            :icon="{ css: 'fas fa-calendar' }"
            v-model="selectedReportDate"
            @select="(value) => { getSetsReport(selectedReportDate) }"
            :items="[
              { name: 'Today', value: 'today' },
              { name: 'Last 7 Days', value: 'last7days' },
              { name: 'Month To Date', value: 'monthToDate' },
          ]"/>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div class="highlight-card">
            <i class="fas fa-user"></i>
            <h2>Visitors</h2>
            <p class="stat">{{ set.views || '0' }}</p>
          </div>
        </div>
        <div class="col-md-4">
          <div class="highlight-card">
            <i class="fas fa-user-check"></i>
            <h2>Completions</h2>
            <p class="stat">{{ set.completions || '0' }}</p>
          </div>
        </div>
        <div class="col-md-4">
          <div class="highlight-card">
            <i class="fas fa-chart-line"></i>
            <h2>Conversion Rate</h2>
            <p class="stat">{{ set.conversion_rate | percentage }}</p>
          </div>
        </div>
      </div>
      <div id="chart"></div>
    </div>
  </div>
</template>
<script>
import ApexCharts from 'apexcharts'
import Reports from '@/resources/TrackingReports.js'
import moment from 'moment'

var chartInstance = null

export default {
  data () {
    return {
      setsReport: [],
      offersReport: null,
      selectedReportDate: { name: 'Today', value: 'today' },
      set: { }
    }
  },
  mounted () {
  },
  methods: {
    setDateRange (date) {
      let dateRange = {}
      dateRange['start_date'] = moment.utc().startOf('day').format('YYYY-MM-DD HH:mm:ss')
      dateRange['end_date'] = moment.utc().endOf('day').format('YYYY-MM-DD HH:mm:ss')
      switch (date.value) {
        case 'today':
          dateRange['start_date'] = moment.utc().startOf('day').format('YYYY-MM-DD HH:mm:ss')
          dateRange['end_date'] = moment.utc().endOf('day').format('YYYY-MM-DD HH:mm:ss')
          break
        case 'monthToDate':
          dateRange['start_date'] = moment.utc().startOf('month').format('YYYY-MM-DD HH:mm:ss')
          dateRange['end_date'] = moment.utc().endOf('month').format('YYYY-MM-DD HH:mm:ss')
          break
        case 'last7days':
          dateRange['start_date'] = moment.utc().subtract('7', 'd').format('YYYY-MM-DD HH:mm:ss')
          dateRange['end_date'] = moment.utc().endOf('date').format('YYYY-MM-DD HH:mm:ss')
          break
      }
      return dateRange
    },
    getSetsReport (dateRange) {
      Reports.sets(this.setDateRange(dateRange))
        .then((response) => {
          this.setsReport = response
          this.set = this.setsReport[0]
          if (this.set && this.set.views) this.getOfferReport(this.setDateRange(dateRange))
        })
    },
    setActiveSet (set) {
      this.getOfferReport(this.setDateRange(this.selectedReportDate))
    },
    getOfferReport (dateRange) {
      let request = {
        'start_date': dateRange['start_date'],
        'end_date': dateRange['end_date'],
        'set_uuid': this.set.set_uuid
      }
      Reports.offers(request)
        .then((response) => {
          this.offersReport = response
          if (this.set.views !== undefined && this.set.views != null) {
            this.configureChart(response, this)
          }
        })
    },
    convertPropertyToArray (data, property) {
      let newArray = []
      for (let i = 0; i < data.length; i++) {
        const offer = data[i]
        if (property === 'dropoff') {
          newArray.push((this.set.views - offer['views']) / this.set.views * 100)
        } else if (property === 'views') {
          newArray.push(parseInt(offer[property]))
        } else {
          newArray.push(offer[property])
        }
      }
      return newArray
    },
    configureChart (data, component) {
      let categories = this.convertPropertyToArray(data, 'name')
      let visitors = this.convertPropertyToArray(data, 'views')
      var options = {
        chart: {
          height: 350,
          type: 'area'
        },
        plotOptions: {
          bar: {
            horizontal: false,
            endingShape: 'flat',
            columnWidth: '55%'
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent'],
          curve: 'straight'
        },
        series: [
          {
            name: 'Visitors',
            data: visitors
          }
        ],
        labels: categories,
        xaxis: {
          // categories: categories
        },
        fill: {
          opacity: 1
        },
        tooltip: {
          custom: function ({ series, seriesIndex, dataPointIndex, w }) {
            let droppercentage = (component.set.views - series[seriesIndex][dataPointIndex]) / component.set.views * 100
            return '<div class="chart-tool-tip" style="padding: 10px">' +
              '<span>Views: ' + series[seriesIndex][dataPointIndex] + '</span><br>' +
              '<span>Drop-off: ' + droppercentage.toFixed(2) + '%</span>' +
              '</div>'
          }
        }
      }
      if (chartInstance) {
        chartInstance.destroy()
      }
      chartInstance = new ApexCharts(
        document.querySelector('#chart'),
        options
      )
      chartInstance.render()
    },
    renderChart () {

    }
  }
}
</script>
<style lang="scss" scoped>
#progression-report-wrapper {
  margin: 0px;
}
.set-report-selects {
  margin-bottom: 10px;
}
.highlight-card {
  background: #f2f2f2;
  border-radius: 5px;
  padding: 15px 20px;
  margin-bottom: 10px;
  i {
    color: #bcbcbc;
    font-size: 36px;
    float: left;
    margin-right: 15px;
    margin-top: 5px;
  }
  h2 {
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 1px;
  }
  p {
    font-size: 24px;
    font-weight: bold;
    padding: 0;
    margin :0;
  }
}
</style>
